import React from 'react';
import MandatAnnulationReductionComponent
  from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatAnnulationReductionComponent';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatAnnulationReductionPanel extends InformationsRattachementPanel {
  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <MandatAnnulationReductionComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default MandatAnnulationReductionPanel;
